import { API } from '@/services/api.service';

export const ALL_STATUSES = [
  'UNREACHABLE',
  'NOT_FULFILLED',
  'PLANNED',
  'FULFILLED',
  'NOT_APPLICABLE',
];

/**
 * One query definition for the page (which only needs to know whether the
 * company has the rule on) and the tab, so the default view is one request.
 */
export const firstPartParams = ({ company, search = '', show = 'open' }) => ({
  company,
  search: search || undefined,
  statuses: show === 'all' ? ALL_STATUSES : undefined,
});

export const firstPartQueryOptions = ({
  company,
  search = '',
  show = 'open',
}) => {
  const params = firstPartParams({ company, search, show });
  return {
    queryKey: ['leaves-overview-first-part', company, search, show],
    queryFn: () => API.employees.getHolidayFirstPartOverview(params),
    enabled: !!company && company !== 'all',
    keepPreviousData: true,
  };
};
